import styled from 'styled-components';

export const CopyrightContainer = styled.div`
  margin: 0;
  font-size: 0.75rem;
  color: #aaa;
  padding: 1rem 0;
  border-top: 1px solid #444;
`;

export const CopyrightGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  max-width: 1200px;
  margin: 0 auto;
  gap: 1rem;
  padding: 0 1rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
  }
`;

export const LeftSection = styled.div`
  text-align: left;
  line-height: 1.5;
`;

export const RightSection = styled.div`
  text-align: center;
  line-height: 1.5;

  @media (max-width: 768px) {
    text-align: center;
    margin-top: 1rem;
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 150px;
  background-color: #444;
  margin: 0 1rem;

  @media (max-width: 768px) {
    width: 100%;
    height: 1px;
    margin: 1rem 0;
  }
`;

export const ContactLink = styled.a`
  color: #aaa;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export const SignatureContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #888;
  justify-content: center;
  span {
    font-weight: 400;
  }
`;

export const SignatureLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})`
  display: inline-flex;
  align-items: center;
  font-size: 1.75rem;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  text-decoration: none;
  color: #0a66c2;

  svg {
    margin-right: 0.4rem;
  }

  &.linkedin {
    color: #0a66c2;
    
    &:hover {
      
      transform: translateY(-2px) scale(1.1);
    }
  }

  span {
    font-size: 0.95rem;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.4rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 0.3rem;
  }
`;